import { forwardRef, type ReactNode } from 'react'

import HTML from '@space-core/components/html'
import LineClamp from '@space-core/components/lineClamp'

import clsx from 'clsx'

import { NotificationContent, NotificationItem } from './styles'

export type NotificationListItemProps = {
  onClick: () => void
  isRead: boolean
  avatar: ReactNode
  content: string
  footer: string
}

const NotificationListItem = forwardRef(
  ({ onClick, isRead, avatar, content, footer }: NotificationListItemProps, ref) => {
    return (
      <hot-dropdown-menu-item ref={ref} onClick={onClick} role='menuitem' class='_px-5 _py-4'>
        <NotificationItem className={clsx({ isUnread: !isRead })}>
          {avatar}
          <NotificationContent>
            <LineClamp lines={2}>
              <HTML className='_d-block'>{content}</HTML>
            </LineClamp>
            <LineClamp lines={1} className='_text-1 _text-gray-500'>
              {footer}
            </LineClamp>
          </NotificationContent>
        </NotificationItem>
      </hot-dropdown-menu-item>
    )
  }
)

export default NotificationListItem
